"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.76.0021H2.24a.56.56,0,0,0-.63.64v19.51a.56.56,0,0,0,.63.64H8.63l3.21,3.15a.24.24,0,0,0,.32,0l3.21-3.15h6.39a.56.56,0,0,0,.63-.64V.6421a.56.56,0,0,0-.63-.64Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,3.14661a7.25,7.25,0,1,0,7.25,7.25A7.25771,7.25771,0,0,0,12,3.14661Zm0,13a5.75,5.75,0,1,1,5.75-5.75A5.75608,5.75608,0,0,1,12,16.14661Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.75,10.08606V7.14661a.75.75,0,1,0-1.5,0v3.25a.74945.74945,0,0,0,.21973.53027l1.625,1.625a.74992.74992,0,1,0,1.06054-1.06055Z",
    fill: "#fff"
  }));
};

exports["default"] = _default;